import BaseService from "./baseService";
import {
    RunExternalFunctionsRequest,
    SaveScenarioGroupLinksRequest,
    ScenarioGroupFileChangeRequest,
    ScenarioGroupFilesContentRequest,
    ScenarioGroupLinksFilter
} from "store/scenarioGroups/types";
//TODO Write annotations to endpoints
export default class extends BaseService {
    constructor() {
        super("api/scenarioGroups");
    }

    getLinks = (filter: Partial<ScenarioGroupLinksFilter>) => this.httpPostRequest("links", filter);

    saveLinks = ({ groupId, scenarioIds, action }: SaveScenarioGroupLinksRequest) => this.httpPutRequest("links", { groupId, scenarioIds, action });

    getGroup = (groupId: number) => this.httpGetRequest(`${groupId}`);

    getGroups = (filter: Record<string, unknown>) => this.httpPostRequest("list", filter);

    runSOM = (groupIds: number[]) => this.httpPostRequest("runSOM", groupIds);

    stopSOM = (groupIds: number[]) => this.httpPostRequest("stopSOM", groupIds);

    runPSO = (groupIds: number[]) => this.httpPostRequest("runPSO", groupIds);

    generateSOMInputs = (groupIds: number[]) => this.httpPostRequest("generateInputs", groupIds);

    cancelSOMInputs = (groupIds: number[]) => this.httpPostRequest("cancelInputs", groupIds);

    saveGroup = (group: Record<string, unknown>) => this.httpPutRequest("", group);

    deleteGroups = (groupIds: number[], deleteScenarios: boolean) => this.httpPostRequest("delete", { groupIds, deleteScenarios });

    uploadInputs = (groupId: number, files: File[]) => {
        const formData = new FormData();
        files.forEach((file, index) => {
            formData.append(`files[${index}]`, file);
        });

        return this.httpPostRequest(`inputs/${groupId}/upload`, formData, { "Content-Type": "multipart/form-data" });
    };

    getInputFiles = (groupId: number) => this.httpGetRequest(`inputs/${groupId}`);

    inputsExist = (groupId: number, fileNames: string[]) => this.httpPostRequest(`inputs/${groupId}/exist`, fileNames);

    getInputUrls = (groupId: number, fileNames: string[]) => this.httpPostRequest(`inputs/${groupId}/urls`, fileNames);

    fetchLogUrl = (groupId: number) => this.httpGetRequest(`logs/${groupId}/url`);

    deleteInputFiles = (groupId: number, fileNames: string[]) => this.httpPostRequest(`inputs/${groupId}/delete`, fileNames);

    copyInputFiles = (sourceId: number, destinationId: number) => this.httpPostRequest(`inputs/${sourceId}/copy/${destinationId}`);

    getResultFiles = (groupId: number) => this.httpGetRequest(`results/${groupId}`);

    getResultUrls = (groupId: number, fileNames: string[]) => this.httpPostRequest(`results/${groupId}/urls`, fileNames);

    getExternalFunctions = (taskId: number) => this.httpGetRequest(`functions/${taskId}`);

    runExternalFunctions = (request: RunExternalFunctionsRequest) => this.httpPostRequest("functions", request);

    getFilesContent = (request: ScenarioGroupFilesContentRequest) => this.httpPostRequest("filesContent", request);

    commitFilesChanges = (request: ScenarioGroupFileChangeRequest) => this.httpPostRequest("saveFileChanges", request);

    getFilesSpecification = (groupId: number) => this.httpGetRequest(`filesSpecification/${groupId}`);
}
